import React from "react";
import { usePaymentProvider } from "./hooks/usePaymentProvider";

export const PaymentContext = React.createContext<
  Partial<ReturnType<typeof usePaymentProvider>>
>({});

export const PaymentProvider: React.FC = ({ children }) => {
  const provider = usePaymentProvider();

  return (
    <PaymentContext.Provider value={provider}>
      {children}
    </PaymentContext.Provider>
  );
};
